<template>
	<div class="page_goods">
		<cube-page type="Goods-view" title="商品详情">
			<div slot="content">
				<van-swipe v-if="isShowDetail" :autoplay="3000" :indicator-color="gcfg.BackgroundColor" class="swipebox">
					<van-swipe-item v-for="(image, index) in detail.imgs_url" :key="index">
						<!-- <van-image :src="image" fit="cover" lazy-load /> -->
						<img v-lazy="image" />
					</van-swipe-item>
				</van-swipe>

				<van-cell-group>
					<van-cell :title="detail.goods_name" :border="false"
						style="font-size:1.2em;margin-bottom:-0.5em;font-weight: bold;" />
					<van-cell v-if="isShowDetail" value="" title-class='titlec'>
						<template slot="icon">
							<van-icon name="discount" size="1.8em" style="margin-right:0.3em;" />
						</template>
						<template slot="title">
							<span class="van-cell-text">同行价：</span>
							<van-tag mark size="large" type="danger">￥{{goods_price}} 起</van-tag>
						</template>
						<div>
							零售价：￥{{line_price}}
						</div>
					</van-cell>
					<van-cell v-if="isShowDetail" :title="'库存：'+stock_num" :value="'销量:'+goods_sales" />
				</van-cell-group>
				<div class="modal_cont_box" :class="isShowDetail ? 'none_margin':''">
					<div class="til_conview" v-if="isShowDetail">
						<van-row class='in-title'>
							<van-col>
								<van-icon name="column" :color="gcfg.BackgroundColor" size="2em" />
							</van-col>
							<van-col><span class="til_con"> 商品描述 </span></van-col>
						</van-row>
					</div>
					<div class="goods-cont-li">
						<div v-html="detail.content"></div>
					</div>

					<Copyright style="margin-bottom:4em"></Copyright>

				</div>
				<van-goods-action v-if="isShowDetail">
					<van-goods-action-button type="danger" text="立即购买" @click="ByNow" />
				</van-goods-action>
			</div>
		</cube-page>
		<van-sku style="width: 100%;" v-model="show" :sku="sku" :goods="goods" :show-add-cart-btn="false"
			:show-soldout-sku="false" buy-text="确定" @buy-clicked="onBuyClicked" @sku-selected="skuSelected"
			@stepper-change="stepperChange">
			<template #sku-header-price="props">
				<div class="van-sku__goods-price">
					<span class="van-sku__price-symbol">￥</span>
					<span class="van-sku__price-num" v-if="!isP">{{ props.price }}</span>
					<span class="van-sku__price-num" v-else>{{ props.selectedSkuComb.price }}</span>
					<div style="padding-left:5px;font-size:12px;color:#969799;">
						零售价：￥
						<span v-if="!isP">{{line_price}}</span>
						<span v-else>{{ props.selectedSkuComb.line_price }}</span>
						<!-- {{line_price}} -->
					</div>
				</div>
			</template>
		</van-sku>
		<!-- 优惠券列表 -->
		<van-popup get-container="getContainer" v-model="showCoupon" closeable close-icon="close" round position="bottom"
			style="height: 90%; padding-top: 4px;">
			<div class="van-coupon-list__list">
				<h5>领取优惠券</h5>
				<div v-if="coupons.length > 0">
					<div class="van-coupon" v-for="(item,index) in coupons" :key="index">
						<div class="van-coupon__content">
							<div class="van-coupon__head">
								<h2 class="van-coupon__amount">{{item.value}}<span>元</span></h2>
								<p class="van-coupon__condition">{{item.type_text}}</p>
							</div>
							<div class="van-coupon__body">
								<p class="van-coupon__name">{{item.title}}</p>
								<p class="van-coupon__valid">{{item.expire_time}}</p>
								<p class="van-refer_to">{{item.refer_to}}</p>
								<div role="checkbox" class="van-checkbox van-coupon__corner">
									<van-button class="coupons-btn" type="danger" size="small" @click="onChange(index)">点击领取
									</van-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<van-empty v-else description="暂无可用优惠券" />
			</div>
			<van-overlay :show="showNumber" @click="showNumber = false">
				<div class="wrapper" @click.stop>
					<div class="block">
						<h3>输入领取数量</h3>
						<van-cell-group>
							<van-field v-model="number" type="digit" label="数量" placeholder="请输入领取数量" />
						</van-cell-group>
						<!--						<div class="message">人/Max：{{maxlength}}</div>-->
						<div class="footer">
							<van-button type="primary" size="small" @click="getCoupon" :loading="disabled">确定</van-button>
							<van-button type="default" size="small" @click="showNumber = false">取消</van-button>
						</div>
					</div>
				</div>
			</van-overlay>
		</van-popup>
	</div>
</template>

<script>
	import CubePage from './TP/cube-page.vue'
	import Copyright from '@/components/TP/Copyright'
	import * as util from '@/utils/network'

	export default {
		data() {
			return {
				storeId: this.$route.query.store_id,
				id: this.$route.query.id + '',
				detail: [],
				gcfg: [],
				cartnum: 0,

				specData: [],
				goods_sku_id: 0, // 规格id
				goods_price: 0,
				stock_num: 0,
				line_price: 0,

				goods_num: 1, //购买数量
				goods_sales: 0, //销量

				goods_spec_arr: [], // 记录规格的数组
				sku_hidden_arr: [], // 记录不显示的sku
				min_price: '',
				show: false,
				goods: {
					// 默认商品 sku 缩略图
					picture: 'https://b.yzcdn.cn/vant/sku/shoes-1.png'
				},
				sku: {
					// 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
					// 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
					tree: [],
					// 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
					list: [],
					price: 0, // 默认价格（单位元）
					stock_num: 10, // 商品总库存
				},
				isP: false,
				showCoupon: false, // 优惠券列表
				chosenCoupon: -1,
				coupons: [],
				role: '20', // 10个人 20 分销商
				showNumber: false,
				number: 1,
				maxlength: 1, // 最大领取数 为点击的对象下的number
				disabled: false,
				isShowDetail:false
			}
		},
		components: {
			CubePage,
			Copyright,
		},
		methods: {
			// 返回一个特定的 DOM 节点，作为挂载的父节点
			getContainer() {
				return document.querySelector('.page_goods');
			},
			onBuyClicked() {
				// if(this.storeId){

				// }else{
				// 	this.$router.push({
				// 		path: '/ddcheckssu', //ddcheckhotel
				// 		query: {
				// 			goods_id: this.id,
				// 			goods_num: this.goods_num,
				// 			goods_sku_id: this.goods_sku_id
				// 		}
				// 	})
				// }
			},
			stepperChange(v) {
				this.goods_num = v
			},
			skuSelected(e) {
				let that = this;
				that.isP = false;
				let seleitem = e.selectedSkuComb
				if (e.selectedSkuComb != null) {
					let arr = that.sku.list;
					for (const elem of arr) {
						if (elem.goods_sku_id == seleitem.goods_sku_id) {
							that.isP = true
							that.sku.price = seleitem.price;
							that.sku.line_price = seleitem.line_price;
							that.stock_num = seleitem.stock_num;
							that.line_price = seleitem.line_price;
							that.goods_sku_id = seleitem.goods_sku_id;
							break;
						}
					}
				}
			},
			ByNow() {
				//this.show = true
				this.$router.push({
					path: '/ddcheckssu', //ddcheckhotel
					query: {
						goods_id: this.id,
					}
				})
			},
			axios_Request() {
				var url = "/addons/litestore/api.goods/detail"
				let that = this;

				//这里直接调用网络接口
				util.get(url, {
						store_id: that.storeId,
						'goods_id': that.id
					},
					function (result) {
						that.goods.picture = result.data.detail.image
						that.sku.price = result.data.min_price;
						that.sku.stock_num = result.data.stock_num;
						that.isShowDetail = result.data.showBuy && result.data.showBuy == 1 ? true : false;
						console.log(that.isShowDetail)
						if (!that.isShowDetail) {
							that.couponClick(result.data.coupon)
						}
						// 初始化商品多规格
						if (result.data.detail.spec_type === '20') {
							that.sku.tree = result.data.skus.tree
							that.sku.list = result.data.skus.list
							that.line_price = result.data.line_price
							that.stock_num = result.data.stock_num
							that.goods_sales = result.data.goods_sales
							that.goods_price = result.data.min_price
						} else {
							that.goods_sku_id = result.data.detail.spec[0].spec_sku_id
							that.goods_price = result.data.detail.spec[0].goods_price
							that.line_price = result.data.detail.spec[0].line_price
							that.stock_num = result.data.detail.spec[0].stock_num
							that.goods_sales = result.data.detail.spec[0].goods_sales
						}
						that.detail = result.data.detail
						that.specData = result.data.specData
						that.min_price = result.data.min_price
					},
				);
			},
			// 优惠券
			couponClick(data) {
				if (data.length > 0) {
					this.$nextTick(() => {
						this.showCoupon = true;
						this.coupons = data;
					})
				}
			},
			// 点击领取
			onChange(index) {
				this.chosenCoupon = index;
				this.number = 1;
				let data = this.coupons[index];
				if (data.max > 0) {
					this.number = data.max;
					this.maxlength = data.max;
				} else {
					this.maxlength = "不限量";
				}
				if (this.role == '20') {
					this.showNumber = true;
				}
			},
			// 输入数量确认
			getCoupon() {
				if (this.maxlength > -1) {
					if (this.number > this.maxlength) {
						this.$toast("领取数量超限");
						return;
					}
				}
				if (this.number < 1) {
					this.$toast("领取数量不能小于1");
					return;
				}
				if (this.number > 1000) {
					this.$toast("无效领取数量");
					return;
				}
				let index = this.chosenCoupon;
				let data = this.coupons[index];
				data.number = this.number;
				console.log(data)
				// 重组id和数量 拼接到订单中
				this.onExchange(data);
			},
			// 领取优惠券
			onExchange(data) {
				let url = '/addons/litestore/api.coupon/receive';
				let {
					activity_id,
					coupon_id,
					number
				} = data;
				let params = {
					activity_id,
					coupon_id,
					number,
					role: this.role
				}
				console.log(params)
				this.disabled = true;
				util.post(url, params, (res) => {
					this.$toast(res.msg);
					this.chosenCoupon = -1;
					this.showNumber = false;
				});
				setTimeout(() => {
					this.disabled = false;
				}, 2000)
			},
		},
		created() {
			this.axios_Request();
			this.gcfg = this.$store.getters.getGcfg
		},
		watch: {
			"$store.state.gcfg": function () {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style scoped="scoped">
	/* /deep/ .van-popup--bottom {
		margin-bottom: 0 !important;
	}

	/deep/ .van-sku-header .van-image {
		width: 96px;
		height: 96px;
	} */

	.swipebox {
		height: 300px;
	}

	.swipebox .van-swipe-item img {
		width: 100%;
	}

	.page_goods {
		height: 100%;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: 28;
	}

	.page_goods .cube-page>.wrapper .content {
		margin: 0px;
	}

	.page_goods .titlec {
		font-size: 1.2em;
		color: #6d189e;
		font-weight: bold;
	}

	.page_goods .yuanjia {
		color: #666;
		text-decoration: line-through;
		margin-left: 1em;
	}

	.page_goods .modal_cont_box {
		box-sizing: border-box;
		padding: 10px 12px;
		background-color: white;
		margin-top: 1em;
	}

	.page_goods .none_margin {
		margin: 0;
		padding: 0;
	}

	.page_goods .til_conview {
		width: 100%;
		border-bottom: 1px solid #eee;
	}

	.page_goods .in-title {
		font-size: 1em;
		color: #6d189e;
		border-bottom: 2px solid #6d189e;
		width: 10em;
		display: block;
		margin: 0 auto;
		line-height: 2em;
		padding: 0em 0 0em 3em;
	}

	.page_goods .til_con {
		font-weight: bold;
		margin-left: 0.2em;
		font-size: 1.1em;
		margin-left: 0.68em;
	}

	.page_goods .tmall-types {
		margin-top: 1em;
	}

	.page_goods .tipstxt {
		font-size: 18px;
		color: rgb(88, 88, 88);
		margin-bottom: 5px;
	}

	.page_goods .radio_c {
		margin-left: -1em;
		padding-top: 0.3em;
	}

	.page_goods .radio_cc {
		display: inline;
		margin-left: 1em;
	}

	.page_goods .van-stepper__input[disabled] {
		color: white !important;
		background-color: #6d189e !important;
		z-index: -9 !important;
	}

	.goods-cont-li {
		width: 100%;
	}

	.page_goods .goods-cont-li img {
		/* max-width: 99% !important; */
		width: 100% !important;
		height: auto;
		display: block;
		margin: 0 auto;
		margin-left: 0rpx;
	}
</style>
<style lang="less" scoped>
	.van-coupon-list__list {
		h5 {
			font-size: 18px;
			margin-bottom: 25px;
			text-align: center;
		}

		.van-refer_to {
			font-size: 12px;
			width: 150px;
			color: #666;
			margin-top: 5px;
		}
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 80%;
		padding: 15px;
		display: flex;
		align-items: center;
		flex-flow: column;
		background-color: #fff;

		h3 {
			margin-bottom: 15px;
		}

		.message {
			justify-content: flex-start;
			width: 100%;
			margin-top: 15px;
			font-size: 14px;
			color: #666;
		}

		.footer {
			margin-top: 15px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			width: 100%;

			button {
				width: 100px;
				margin-left: 15px;
			}
		}
	}

	.coupons-btn {
		border-radius: 4px;
	}

	.nocoupons {
		background: #dfdfdf;

		.coupons-btn {
			background: #999;
			border-color: #999;
		}
	}

	.van-popup--bottom {
		width: 100% !important;
		margin: 0 !important;
	}
</style>
